import styled from 'styled-components';
import { colors, typography } from '../../../styles/theme';

export const Wrapper = styled.div`
  display: flex;
  overflow: hidden;
  flex-direction: column;
  box-sizing: border-box;
  height: 100%;
`;

export const Content = styled.section`
  width: 100%;
  flex-grow: 1;
`;

export const Title = styled.h1`
  font-size: 36px;
  font-weight: ${typography('weights.bold')};
  color: ${colors('accent')};
  margin-bottom: 8px;
`;

export const AlertContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;

  padding: 16px;

  margin-top: 84px;

  /* danger-50 */
  background-color: #fff5f5;

  /* danger-500 */
  border: 1px solid #e53e3e;
  border-radius: 8px;

  svg {
    flex-shrink: 0;
  }
`;

export const AlertContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const AlertTitle = styled.h1`
  /* danger-700 */
  color: #9b2c2c;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 24px */
`;

export const AlertDescription = styled.p`
  /* danger-700 */
  color: #9b2c2c;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
`;
